import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route } from "react-router";
import { ReduxRouter } from "redux-router";
import { ToastContainer } from "react-toastify";
import { configureStore, sagaMiddleware } from "./store/configureStore";
import AppRouter from "./routes";
import Modal from "containers/Modal/Modal.jsx";
import AxiosConfigurator from "services/axios_config.js";
import storage from "services/storage";
import sagas from "sagas";
import { loginSaga } from "sagas/auth.js";

import "react-select/dist/react-select.css";
import "react-quill/dist/quill.snow.css";
import "assets/css/App.scss";
require.context("assets/img", true, /\..*$/);
require.context("assets/fonts", true, /\..*$/);

const { session, user } = storage.getSessionData();

const store = configureStore({
  session,
  users: {
    user,
    showProfileConfirmation: false,
    adminUsers: { values: [], page: 0, pages: 0 },
    assignedUsers: { values: [], page: 0, pages: 0 },
    confirmationUsers: { values: [], page: 0, pages: 0 },
    statistics: {
      registered: 0,
      logged: 0,
      user_type: 0,
      hospital: 0,
      county: 0,
    },
    tmp: {},
    adminWebinarRegisteredUsers: [],
  },
});

// Run all sagas
sagaMiddleware.run(sagas);

const axiosConfig = new AxiosConfigurator(store);
// axiosConfig.configureAxios();

class Root extends Component {
  render() {
    return (
      <div>
        <Provider store={store}>
          <AppRouter>
            <ToastContainer
              autoClose={10000}
              closeButton={false}
              className="toast-container"
              toastClassName="dark-toast"
            />
            <Modal />
          </AppRouter>
        </Provider>
      </div>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js